import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { IFilaCV, IFiltrosBusquedaCV, IListadoCV, IOpcionCurr } from 'src/model/candidato-api'
import { BusquedaCV } from '../../model/busqueda-cv'
import { BaseFeaturesComponent } from '../_base/base-features.component'

class PanelCurriculumsComponentCtrl extends BaseFeaturesComponent {
  busqueda = new BusquedaCV()
  selecciones: IOpcionCurr[]

  $loading = false
  listado: IListadoCV
  listadolist: IFilaCV[]

  panelcv = {
    $visible: false,
    cv: null as IFilaCV,
  }

  datosTipos: TiposDocEstadosStore

  columnaMiddleMan = true

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[PanelCurriculumsComponentCtrl] onInit')

    // al inicio, obtener los ítems de menú disponibles, no solo los visibles
    this.AccesoDatos.GestionCurr_CLIENT.opcionesSeleccionCurriculums().then((selResponse) => {
      this.selecciones = selResponse.listaSelecciones
    })

    this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(
      (tiposResponse) => (this.datosTipos = new TiposDocEstadosStore(tiposResponse))
    )

    this.columnaMiddleMan = this.usercfg && this.usercfg.adm && this.usercfg.options.app === 'MODIFCONTRATOS'
  }

  listacv() {
    if (this.usercfg.adm) this.AccesoDatos.GestionCurr_CLIENT.lastCV()
    else this.AccesoDatos.GestionSolicitudes_CLIENT.lastCV()
  }

  busquedacv() {
    this.$loading = true
    this.listado = null

    this._callbackBusqueda(this.busqueda.generaFiltros()).then((listadoResponse) => {
      this.$log.info('listado', listadoResponse)
      this.listado = listadoResponse
      this.listadolist = listadoResponse.list
    })
  }

  private _callbackBusqueda(filtros: IFiltrosBusquedaCV) {
    if (this.usercfg.adm) return this.AccesoDatos.GestionCurr_CLIENT.findCV(filtros)
    else return this.AccesoDatos.GestionSolicitudes_CLIENT.findCV(filtros)
  }

  seleccionaForm() {
    // obtener las preguntas del formulario
    this.AccesoDatos.GestionCurr_CLIENT.pregsSeleccionCurriculums(this.busqueda.opt.item.idm).then((formResponse) => {
      this.busqueda.pregslist = formResponse.listPreguntas
      this.busqueda.selMenu(this.busqueda.opt.item)
      // generar una nueva selección de pregunta
      // this.busqueda.nuevaCondicion()
    })
  }

  otraCondicion() {
    this.busqueda.nuevaCondicionPregunta()
  }

  filtroEstado() {
    this.busqueda.estado = true

    this.busqueda.nuevaCondicionEstado()
  }

  filtroFechas() {
    this.busqueda.fechas = true

    this.busqueda.nuevaCondicionFechas()
  }

  accesscv(idx: number) {
    this.$log.debug('access', this.listado.list[idx])
    this.panelcv.cv = this.listado.list[idx]
    this.panelcv.$visible = true
  }

  exportcv() {}

  clearForm() {
    this.busqueda = new BusquedaCV()
  }

  quitarCondicion(idx: number) {
    this.busqueda.quitarCondicion(idx)
  }
}

angular.module('candidato').component('panelCurriculums', {
  bindings: {},
  controller: PanelCurriculumsComponentCtrl,
  template: require('./panel-curriculums.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-curriculums/panel-curriculums.component.html"
})

angular.module('candidato').filter('datestr', ($log: ILogService) => {
  return (datestr: string) => {
    if (!datestr) return ''

    $log.debug('====> datestr ', datestr)

    return new Date(datestr).toLocaleDateString('es')
  }
})
